import { defineComponent as _defineComponent } from 'vue'
import ToIcon from '@/components/to-icon/to-icon.vue'
import {
    ExportDialogTextContent,
    Format,
    TemplateItem,
    TriggerExportInput
} from '@/ui/export-dialog/export-dialog.types'
import { computed, onMounted, ref } from 'vue'
import TmButton from '@/ui/tm-button/tm-button.vue'

interface Props {
    open: boolean
    cancel: () => void
    textContent: ExportDialogTextContent
    templates: Array<TemplateItem>
    formats: Array<Format>
    runExport: (input: TriggerExportInput) => Promise<string>
    track: (format: Format) => void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'export-dialog',
  props: {
    open: { type: Boolean },
    cancel: null,
    textContent: null,
    templates: null,
    formats: null,
    runExport: null,
    track: null
  },
  setup(__props: any) {

const props = __props as {
    open: boolean
    cancel: () => void
    textContent: ExportDialogTextContent
    templates: Array<TemplateItem>
    formats: Array<Format>
    runExport: (input: TriggerExportInput) => Promise<string>
    track: (format: Format) => void
}




const selectedFormat = ref<Format | null>(null)
const exportTemplate = ref<string | null>(null)
const exportInProgress = ref(false)
const downloadUrl = ref<string | null>(null)
const exportFailed = ref(false)

const formatLabels: Record<Format, string> = {
    pptx: 'PowerPoint',
    pdf: 'PDF',
    xlsx: 'Excel'
}

async function onExport () {
    exportInProgress.value = true
    try {
        downloadUrl.value = await props.runExport({
            format: selectedFormat.value || 'pdf',
            template: exportTemplate.value
        })
        props.track(selectedFormat.value || 'pdf')
    } catch (e) {
        // eslint-disable-next-line no-console
        console.log('%cError on export mutation: ', 'color:red', e)
        exportFailed.value = true
    } finally {
        exportInProgress.value = false
    }
}

const submitDisabled = computed((): boolean => {
    if (selectedFormat.value === null) {
        return true
    }

    if (selectedFormat.value === 'xlsx') {
        return false
    }

    return (props.templates.length > 1 && exportTemplate.value === null)
})

const showTemplateSelection = computed((): boolean => {
    return selectedFormat.value !== null && ['pptx', 'pdf'].includes(selectedFormat.value) && props.templates.length > 1
})

onMounted(() => {
    exportTemplate.value = props.templates.length > 0 ? props.templates[0].value : null
})

const handleClose = () => {
    selectedFormat.value = null
    exportTemplate.value = null
    exportInProgress.value = false
    downloadUrl.value = null
    exportFailed.value = false

    props.cancel()
}


return { __sfc: true,props, selectedFormat, exportTemplate, exportInProgress, downloadUrl, exportFailed, formatLabels, onExport, submitDisabled, showTemplateSelection, handleClose, ToIcon, TmButton }
}

})